import UsuarioCellData from "@/components/Tablas/TableBase/UsuarioCell/UsuarioCell";
import { memo } from "react";
import { IUser } from "@/redux/models";

const UserMemo = ({ user }: { user: IUser }) => {
    return <UsuarioCellData usuario={user} />
}

export default memo(UserMemo)